'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HeaderCell = require('./table/HeaderCell');

var _HeaderCell2 = _interopRequireDefault(_HeaderCell);

var _TableCell = require('./table/TableCell');

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableHead = require('./table/TableHead');

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableBody = require('./table/TableBody');

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableRow = require('./table/TableRow');

var _TableRow2 = _interopRequireDefault(_TableRow);

var _reactDimensions = require('react-dimensions');

var _reactDimensions2 = _interopRequireDefault(_reactDimensions);

var _reactDemo = require('react-demo');

var _reactDemo2 = _interopRequireDefault(_reactDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    _classCallCheck(this, Table);

    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
  }

  _createClass(Table, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          containerWidth = _props.containerWidth,
          maxWidth = _props.maxWidth,
          gutterClassName = _props.gutterClassName;


      return { containerWidth: containerWidth, maxWidth: maxWidth, gutterClassName: gutterClassName };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          responsive = _props2.responsive,
          containerWidth = _props2.containerWidth,
          containerHeight = _props2.containerHeight,
          maxWidth = _props2.maxWidth,
          updateDimensions = _props2.updateDimensions,
          gutterClassName = _props2.gutterClassName,
          rest = _objectWithoutProperties(_props2, ['style', 'responsive', 'containerWidth', 'containerHeight', 'maxWidth', 'updateDimensions', 'gutterClassName']);

      var table = _react2.default.createElement('table', _extends({ style: _extends({ width: '100%' }, style) }, rest));

      if (!responsive) {
        return table;
      }

      return _react2.default.createElement(
        'div',
        { style: { overflow: 'auto', width: '100%', WebkitOverflowScrolling: 'touch' } },
        table
      );
    }
  }]);

  return Table;
}(_react.Component);

Table.propTypes = {
  containerWidth: _react.PropTypes.number.isRequired,
  containerHeight: _react.PropTypes.number.isRequired,
  maxWidth: _react.PropTypes.number,

  responsive: _react.PropTypes.bool,
  gutterClassName: _react.PropTypes.string
};
Table.defaultProps = {
  maxWidth: 1400,

  responsive: true,
  gutterClassName: 'hidden-print'
};
Table.childContextTypes = {
  containerWidth: _react.PropTypes.number,
  maxWidth: _react.PropTypes.number,
  gutterClassName: _react.PropTypes.string
};

Table.demo = function () {
  return _react2.default.createElement(
    _reactDemo2.default,
    { props: {
        containerWidth: _reactDemo.props.number(500),
        containerHeight: _reactDemo.props.number(500),
        maxWidth: _reactDemo.props.number(500),
        striped: _reactDemo.props.bool(true)
      } },
    function (props, update) {
      return _react2.default.createElement(
        Table,
        props,
        _react2.default.createElement(
          _TableHead2.default,
          null,
          _react2.default.createElement(
            _HeaderCell2.default,
            { sorted: 'A' },
            'Component Name'
          ),
          _react2.default.createElement(
            _HeaderCell2.default,
            null,
            'Component Description'
          ),
          _react2.default.createElement(
            _HeaderCell2.default,
            null,
            'Props'
          )
        ),
        _react2.default.createElement(
          _TableBody2.default,
          { striped: props.striped },
          _react2.default.createElement(
            _TableRow2.default,
            { key: 'Table' },
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'The top-level Table component. It has several static methods that are subcomponents: thead, tbody, th, tr, td'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              _react2.default.createElement(
                'p',
                null,
                'Table expects a "maxWidth" prop, which defaults to 1400 (pixels) and represents the maximum width of the table on the page.'
              )
            )
          ),
          _react2.default.createElement(
            _TableRow2.default,
            null,
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.thead'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.thead contains all the Table.th components'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              _react2.default.createElement(
                'p',
                null,
                'Put your Table.th components in here'
              )
            )
          ),
          _react2.default.createElement(
            _TableRow2.default,
            null,
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.th'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.th is the component for an individual header cell.'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              _react2.default.createElement(
                'p',
                null,
                'Takes `onSort` and `sorted` props'
              )
            )
          ),
          _react2.default.createElement(
            _TableRow2.default,
            null,
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.tbody'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.tbody is the containing component for the table body. It requires children, which are a series of Table.tr components.'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              _react2.default.createElement(
                'p',
                null,
                'Table.tbody should contain `Table.tr`s. It also takes the following optional props:'
              )
            )
          ),
          _react2.default.createElement(
            _TableRow2.default,
            null,
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.tr'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.tr is the component for a table row.'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              _react2.default.createElement(
                'p',
                null,
                'Table.tr contains all your Table.td. Pass any onClick handlers, classNames, or styles to this component'
              )
            )
          ),
          _react2.default.createElement(
            _TableRow2.default,
            null,
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.td'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              null,
              'Table.td is the component for an individual cell in a table row.'
            ),
            _react2.default.createElement(
              _TableCell2.default,
              { className: 'pd-left-sm pd-right-sm' },
              _react2.default.createElement(
                'p',
                null,
                'Pass any styles to this component.'
              )
            )
          )
        )
      );
    }
  );
};

exports.default = Object.assign((0, _reactDimensions2.default)()(Table), {
  demo: Table.demo,
  thead: _TableHead2.default,
  td: _TableCell2.default,
  th: _HeaderCell2.default,
  tbody: _TableBody2.default,
  tr: _TableRow2.default
});


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/Table.js
// module id = 407
// module chunks = 0